var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18173_524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 11.0007H7.82998L12.71 6.1207C13.1 5.7307 13.1 5.0907 12.71 4.7007C12.32 4.3107 11.69 4.3107 11.3 4.7007L4.70998 11.2907C4.31998 11.6807 4.31998 12.3107 4.70998 12.7007L11.3 19.2907C11.69 19.6807 12.32 19.6807 12.71 19.2907C13.1 18.9007 13.1 18.2707 12.71 17.8807L7.82998 13.0007H19C19.55 13.0007 20 12.5507 20 12.0007C20 11.4507 19.55 11.0007 19 11.0007Z",
    fill: "#949494"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18173_524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.8eb17028.svg";
export { ForwardRef as ReactComponent };